import React from "react";
import images from "../../../utilities/images/images";
import StoreRibbonTag from "./StoreRibbonTag";
import DashboardBenefitTick from "./DashboardBenefitTick";
import PackageBottomNote from "./PackageBottomNote";
import {
  formatPrice,
  getDiscountPercent,
  getFinalAmount,
  hasPackageDiscount,
} from "../utils/coursePricing";
import { isVariantPackage, isPackagePurchased, shouldShowBuyNow } from "../utils/explorePackage";
import { getExploreCourseAnchorId } from "../utils/exploreCoursesScrollRestore";
import { getExploreCardClassName } from "../utils/exploreCardHighlight";
import "./DashboardBenefitTick.css";
import "./PackageBottomNote.css";
import "./dashboardExploreCard.css";
import "./RecommendedCourseCard.css";

const RecommendedCourseCard = ({
  course,
  section = "recommended",
  highlightedAnchorId = null,
  onDetails,
  onBuy,
  onOpenVariants,
}) => {
  const finalAmount = getFinalAmount(course?.amount, course?.discount);
  const showDiscount = hasPackageDiscount(course?.amount, course?.discount);
  const discountLabel = getDiscountPercent(course?.amount, course?.discount);
  const isPurchased = isPackagePurchased(course);
  const showBuyNow = shouldShowBuyNow(course);
  const isVariant = isVariantPackage(course);
  const benefits = Array.isArray(course?.course_benefits)
    ? course.course_benefits.slice(0, 2)
    : [];

  const anchorId = course?.package_id
    ? getExploreCourseAnchorId(course.package_id, section)
    : undefined;
  const isSelected = Boolean(anchorId && highlightedAnchorId === anchorId);

  return (
    <article
      className={getExploreCardClassName(
        "recommended-course-card",
        anchorId,
        highlightedAnchorId
      )}
      id={anchorId}
      aria-current={isSelected ? "true" : undefined}
    >
      <div className="recommended-course-card__head">
        {course?.thumbnail_tag ? (
          <div className="recommended-course-card__tag-wrap">
            <StoreRibbonTag
              label={course.thumbnail_tag}
              background={course?.tag_background || "#148e00"}
              color={course?.tag_textcolor || "#ffffff"}
            />
          </div>
        ) : null}

        <h3 className="recommended-course-card__title">{course?.package_name || "—"}</h3>
      </div>

      {benefits.length ? (
        <ul className="dashboard-benefit-list dashboard-benefit-list--recommended recommended-course-card__benefits">
          {benefits.map((benefit) => (
            <li key={benefit} className="dashboard-benefit-list__item">
              <DashboardBenefitTick />
              <span className="dashboard-benefit-list__text">{benefit}</span>
            </li>
          ))}
        </ul>
      ) : null}

      <div className="recommended-course-card__price-row">
        <div className="recommended-course-card__prices">
          <strong>{formatPrice(finalAmount)}</strong>
          {showDiscount ? (
            <span className="recommended-course-card__strike">
              {formatPrice(course.amount)}
            </span>
          ) : null}
        </div>
        {discountLabel ? (
          <span className="recommended-course-card__discount">{discountLabel}</span>
        ) : null}
      </div>

      <div
        className={`recommended-course-card__actions${
          isPurchased ? " recommended-course-card__actions--purchased" : ""
        }`}
      >
        <button
          type="button"
          className="recommended-course-card__btn recommended-course-card__btn--outline"
          onClick={onDetails}
        >
          Course details
        </button>
        {!showBuyNow ? null : (
          <button
            type="button"
            className="recommended-course-card__btn recommended-course-card__btn--primary"
            onClick={onBuy}
          >
            Buy Now
            {isVariant ? (
              <img
                src={images.downArrow}
                alt=""
                className="recommended-course-card__btn-icon"
                aria-hidden="true"
              />
            ) : null}
          </button>
        )}
      </div>

      <PackageBottomNote
        course={course}
        onOpenVariants={onOpenVariants}
        className="recommended-course-card__bottom-note"
      />
    </article>
  );
};

export default RecommendedCourseCard;
